import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { useTranslation } from 'react-i18next';
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';
import { pagePath } from '../../../app/utils/consts/pagePath';
import { Button } from '../Button';

export default function RouteErrorBoundary() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = useRouteError();

  const technicalMessage = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : null;

  return (
    <div className="bg-surface-page text-text-primary flex min-h-dvh flex-col items-center justify-center gap-4 p-6">
      <div className="bg-surface-elevated flex w-full max-w-md flex-col items-center gap-4 rounded-lg p-8 shadow">
        <div className="rounded-full bg-red-100 p-3 dark:bg-red-900/40">
          <ExclamationTriangleIcon className="size-8 text-red-600 dark:text-red-400" />
        </div>

        <h1 className="text-text-primary text-center text-xl font-semibold">
          {t('errors.boundary.title')}
        </h1>

        <p className="text-text-secondary text-center text-sm">
          {t('errors.boundary.description')}
        </p>

        {technicalMessage && (
          <code className="bg-surface-input text-text-tertiary w-full overflow-x-auto rounded px-3 py-2 text-xs">
            {technicalMessage}
          </code>
        )}

        <div className="mt-2 flex w-full flex-col gap-2 sm:flex-row">
          <Button
            color="outline"
            className="flex-1"
            onClick={() => window.location.reload()}
          >
            {t('errors.boundary.retry')}
          </Button>
          <Button
            className="flex-1"
            onClick={() => navigate(pagePath.home, { replace: true })}
          >
            {t('errors.boundary.home')}
          </Button>
        </div>
      </div>
    </div>
  );
}
